import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, input, OnInit, signal } from '@angular/core';
import { SlideComponent } from '../slide/slide.component';
import { FetchService } from 'src/app/services/fetch.service';
import { SlideImage } from '@chemist2u/types-client/C2U/ParseObjects';

@Component({
    selector: 'app-slides',
    templateUrl: './slides.component.html',
    styleUrls: ['./slides.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    imports: [SlideComponent]
})
export class SlidesComponent implements OnInit {
  private $fetch = inject(FetchService);

  public large = input<boolean>(false);
  
  public slides = signal<SlideImage[]>([]);

  ngOnInit() {
    this.fetchSlides();
  }

  async fetchSlides() {
    const slides = await this.$fetch.slides();
    this.slides.set(slides);
  }
}
